/**
 * The "People known by name" set, shared by the Website tile and the table so
 * the two can't disagree (on 12 Oct the tile said 17 and the table listed 16:
 * the tile only dropped test addresses, the table also dropped "TEST …" names).
 *
 * Someone who filled in a form has the fuller journey, so their RB2B duplicate
 * is dropped; QA identities are dropped from both and counted.
 */
export function knownPeople<
  J extends { email: string; fullName?: string | null },
  P extends { email: string; fullName?: string | null },
>(journeys: readonly J[], people: readonly P[]): { forms: J[]; rb2b: P[]; hiddenTests: number } {
  const formEmails = new Set(journeys.map((j) => j.email));
  const rb2bAll = people.filter((p) => !formEmails.has(p.email));
  const forms = journeys.filter((j) => !isTestPerson(j.email, j.fullName));
  const rb2b = rb2bAll.filter((p) => !isTestPerson(p.email, p.fullName));
  return { forms, rb2b, hiddenTests: journeys.length + rb2bAll.length - forms.length - rb2b.length };
}

/**
 * A QA person: a test address, or a name tagged as a test ("TEST Fillout Updated
 * logo" came from a real-looking address, so the email rule alone kept it).
 */
export function isTestPerson(email: string | null | undefined, fullName: string | null | undefined): boolean {
  return isTestEmail(email) || (!!fullName && /\btest\b/i.test(fullName));
}

/** QA identities: an address with "test" in it, or anyone at the test-sequesto.com domain. */
export function isTestEmail(email: string | null | undefined): boolean {
  return !!email && (/test/i.test(email) || /@test-sequesto\.com$/i.test(email));
}
